<div class="personal-infomation p-4 mt-4" id="work-experience">
    <div class=" d-flex justify-content-between ">
        <h2 class="profile-heading" id="workingExperiences">Work Experience</h2>
        <div class="d-flex">
            <img class="edit-profile mx-1" (click)="addWork()"
                *ngIf="(endCustomerData?.workInfos && this.endCustomerData.workInfos.length>0) || showEditForm" alt=""
                src="../../assets/images/add.svg" id="add-icon5">
            <img class="edit-profile " (click)="editWork()"
                *ngIf="(endCustomerData?.workInfos && this.endCustomerData.workInfos.length>0)&& !showEditForm " alt=""
                src="../../assets/images/editprofile.svg" id="edit-icon5">
        </div>

    </div>
    <div class="mt-2" *ngIf="!(endCustomerData?.workInfos && this.endCustomerData.workInfos.length>0) && !showEditForm">
        <button (click)="addFirstWork()" class="profile-btn">
            <mat-icon>add</mat-icon>
            <p class="ps-2" id="add-work-experience">Add Work Experience</p>
        </button>
    </div>

    <div class="mt-2" *ngIf="(endCustomerData?.workInfos && this.endCustomerData.workInfos.length>0) && !showEditForm">


        <app-card-profile [image]="hospitalIcon" [data]="data" [isWorkCard]="true" [keys]="workExpColumns">
        </app-card-profile>

    </div>
    <form [formGroup]="workExperienceForm" class="mt-2" *ngIf="showEditForm">
        <div formArrayName="workInfos">
            <div *ngFor="let workExperienceForm of workInfos.controls;let i=index;">
                <div [formGroupName]="i">
                    <div class="row mb-4">
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="row work">
                                    <div class="col-lg-3 my-1 end-customer-experience">
                                        <div>
                                            <p
                                                class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                                Designation</p>
                                        </div>
                                        <div>
                                            <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                                <input matInput formControlName="designation" placeholder="Enter Designation" (keydown)="handleKeyDown($event)">
                                <mat-error class="error-message error-msg end-customer-experience-error" *ngIf="workExperienceForm.get('designation')?.hasError('pattern') || workExperienceForm.get('designation')?.hasError('maxlength')"><img class="error-icon"
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" /> {{workExperienceForm.get('designation')?.hasError('pattern') ? ' Only Alphabets are allowed' : ' Limit Exceeded: Max 50 characters'}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 end-customer-experience">
                                        <div>
                                            <p
                                                class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 mt-2">
                                                From</p>
                                        </div>
                                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                            <input matInput [matDatepicker]="fromDate" formControlName="fromDate" (dateChange)="onFromDateChange($event)" (keydown)="handleKeyDown($event)">
                                            <mat-datepicker-toggle matIconSuffix [for]="fromDate"></mat-datepicker-toggle>
                                            <mat-datepicker #fromDate color="primary"></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-4 end-customer-experience">
                                        <div>
                                            <p
                                                class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0 mt-2">
                                                To</p>
                                        </div>
                                        <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                            <input matInput [matDatepicker]="toDate" formControlName="toDate" [min]="minToDate" (keydown)="handleKeyDown($event)">
                                            <mat-datepicker-toggle matIconSuffix [for]="toDate"></mat-datepicker-toggle>
                                            <mat-datepicker #toDate color="primary"></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-3 my-1 end-customer-experience">
                                        <div>
                                            <p
                                                class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                                Organization</p>
                                        </div>
                                        <div>
                                            <mat-form-field appearance="outline" class="fields input-font w-100 b-r">
                                                <input matInput formControlName="organization" placeholder="Enter Organization Name" (keydown)="handleKeyDown($event)">
                                                <mat-error class="error-message error-msg end-customer-experience-error"
                            *ngIf="workExperienceForm.get('organization')?.hasError('pattern') || workExperienceForm.get('organization')?.hasError('maxlength')"><img class="error-icon"
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" /> {{workExperienceForm.get('organization')?.hasError('pattern') ? ' Only Alphanumerics are allowed' : ' Limit Exceeded: Max 150 characters'}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 my-1 end-customer-experience">
                                        <div>
                                            <p
                                                class="med-world-basic-font med-world-basic-font__large med-world-basic-font__weight secondary_black_color m-0">
                                                Location</p>
                                        </div>
                                        <div>
                                            <mat-form-field appearance="outline" class="fields input-font w-100 b-r">
                                                <input matInput formControlName="location" placeholder="Enter Location" (keydown)="handleKeyDown($event)">
                                                <mat-error class="error-message error-msg end-customer-experience-error"
                            *ngIf="workExperienceForm.get('location')?.hasError('pattern') || workExperienceForm.get('location')?.hasError('maxlength')"><img class="error-icon"
                                loading="lazy" alt="" src="./../../assets/images/alert.svg" /> {{workExperienceForm.get('location')?.hasError('pattern') ? ' Only Alphabets are allowed' : ' Limit Exceeded: Max 50 characters'}}</mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-lg-3">

                                        <button class=" delete" (click)="deleteWork(i)"><img alt=""
                                                src="./../../assets/images/Trash bin.svg">
                                            <span class="deltext">Delete</span>
                                        </button>
                                    </div>
                                </div>
                                
                                </div>
                                </div>
                                </div>
                    </div>
                    </div>
                    </div>
                    </form>
                    <div class="profile-action " *ngIf="showEditForm">
                        <button  class="mwe-button mwe-button--primary med-world-basic-font med-world-basic-font__medium ps-3 pe-3" (click)="update()">Update</button>
                        <button  class="mwe-button mwe-button--secondary ps-3 pe-3 "  (click)="cancel()">Cancel</button>
                    </div>
</div>